import { editorViewportNodeCss } from 'craft/containers/Viewport/modes/components';
import { GlobalStyles } from 'styleguide/GlobalStyles';
import { EditorRebootReverse } from 'styleguide/reboot-reverse.css';

export const syncPlaceholderStyles = `
  <style type="text/css">
    ${GlobalStyles}
    ${EditorRebootReverse}
    ${editorViewportNodeCss}

    /*
     More generic styles that need specific overrides for the placeholder to display properly
     */

     /* These styles are needed to simulate the styles components would normally inherit from the body */
     #element-root {
      font-family: sofia-pro, sans-serif;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5;
      font-style: normal;
      text-align: left;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
     }

    .candu-button {
      display: inline-block;
    }
  </style>

`;
